import React from 'react';

import cx from 'classnames';

import s from './index.module.css';

export function Subtitle(props) {
  const { children, title } = props;

  return (
    <div className={cx(s.wrapper, 'custom-head-subtitle-wrapper')}>
      <div className={cx(s.subtitle, 'custom-head-subtitle')}>{title}</div>
      {children && <div className={cx(s.hint, 'custom-head-subtitle-hint')}>{children}</div>}
    </div>
  );
}
